import { render, staticRenderFns } from "./fileCollect.vue?vue&type=template&id=349710f8&scoped=true"
import script from "./fileCollect.vue?vue&type=script&lang=js"
export * from "./fileCollect.vue?vue&type=script&lang=js"
import style0 from "./fileCollect.vue?vue&type=style&index=0&id=349710f8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349710f8",
  null
  
)

export default component.exports